export function backupBlockReason({ online, pending = 0, busy = false, error = '', needsRefresh = false }) {
  if (!online) return 'Connect to the internet and sync pending changes before creating a backup.';
  if (busy) return 'Sync is still running. Wait for it to finish before creating a backup.';
  if (pending || error || needsRefresh) return 'Sync all pending changes successfully before creating a backup, so no local edits are omitted.';
  return '';
}
